import React from 'react'

const Columns = ({attrs}) => {
	// Validation des props
	if (!attrs || typeof attrs !== 'object') {
		return (
			<div role="alert" aria-live="polite" className="columns-error">
				Configuration des colonnes invalide
			</div>
		)
	}

	// Vérification du nombre de colonnes
	const columnsCount = attrs.columns_nb_columns || 0
	if (columnsCount === 0) {
		return (
			<div role="alert" aria-live="polite" className="columns-error">
				Nombre de colonnes non défini
			</div>
		)
	}

	// Filtrage des colonnes valides
	const columnKeys = Object.keys(attrs).filter(key => key.startsWith("columns_column_"))
	
	if (columnKeys.length === 0) {
		return (
			<div role="alert" aria-live="polite" className="columns-error">
				Aucune colonne trouvée
			</div>
		)
	}

	return (
		<div 
			className={`wp-columns has-${columnsCount}-columns`}
			role="grid"
			aria-label={`Grille de ${columnsCount} colonnes`}
			aria-colcount={columnsCount}
			aria-rowcount="1"
		>
			<div role="row">
				{columnKeys.map((key, index) => (
					<div 
						key={key} 
						className={`wp-columns-column ${key}`}
						role="gridcell"
						aria-colindex={index + 1}
						aria-label={`Colonne ${index + 1}`}
						dangerouslySetInnerHTML={{__html: attrs[key]}}
					/>
				))}
			</div>
		</div>
	)
}

export default Columns
